/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Style from './style';
import Widget from '../../widget';
import { WIDTH, usePreInvestement } from './helper';

const emptyData = [
  { "label": "Production", "Comparison": 0, "Baseline": 0, Current: 0 },
  { "label": "Bags", "Comparison": 0, "Baseline": 0, Current: 0 },
  { "label": "Workers", "Comparison": 0, "Baseline": 0, Current: 0 },
  { "label": "Permits & Licenses", "Comparison": 0, "Baseline": 0, Current: 0 },
  { "label": "Equipment", "Comparison": 0, "Baseline": 0, Current: 0 },
];

export default function PreInvestment() {
  const { t } = useTranslation();
  const data = useMemo(() => emptyData, []);

  const { graphWidth, container } = usePreInvestement({ data });

  return (
    <Widget
      className="with-border-header no-px h-w-btn-header"
      title={t('Pre Investment & KYC Assessment')}
    >
      <div className='flex flex-1 flex-column justify-content-center'>
        <div className='flex justify-content-center'>
          <Style
            style={{
              maxWidth: WIDTH,
              marginTop: graphWidth ? 'auto' : undefined,
              marginBottom: graphWidth ? 'auto' : undefined,
              flex: graphWidth ? 'unset' : 1,
              textAlign: 'center',
            }}
            ref={container}
          >
            <div className='label label-a'>{t('Production')}</div>
            <div className='label label-b'>{t('Bags')}</div>
            <div className='label label-c'>{t('Workers')}</div>
            <div className='label label-d'>{t('Permits & Licenses')}</div>
            <div className='label label-e'>{t('Equipment')}</div>
          </Style>
        </div>
      </div>
    </Widget>
  )
}
